import React, { type FC } from 'react';
import { DisplayList } from '../common/DisplayList';
import { CustomListDataRow, getCustomDataItems } from '../../utility/customListFields';

export type PropertyCustomDataRow = CustomListDataRow & {
  list_upload_id?: string;
  list_upload?: { id: string; list_name: string } | null;
};

type PropertyCustomDataProps = {
  listUploadsPropertiesData?: PropertyCustomDataRow[] | null;
};

// "Custom Data" section: the optional fields the user mapped when uploading each list this
// property belongs to. Renders nothing when there is no custom data to show.
export const PropertyCustomData: FC<PropertyCustomDataProps> = ({ listUploadsPropertiesData }) => {
  const sections = (listUploadsPropertiesData ?? [])
    .map((row) => ({ row, items: getCustomDataItems(row) }))
    .filter(({ items }) => items.length > 0);

  if (sections.length === 0) {
    return null;
  }

  const showListNames = sections.length > 1;

  return (
    <div id="property-custom-data" className="m-4 py-2">
      {sections.map(({ row, items }, index) => (
        <div key={row.list_upload_id ?? index} className={index > 0 ? 'mt-6' : ''}>
          <DisplayList title={showListNames && row.list_upload?.list_name ? `Custom Data: ${row.list_upload.list_name}` : 'Custom Data'} items={items} />
        </div>
      ))}
    </div>
  );
};
